module.exports = __webpack_public_path__ + "img/requeteur_create.caddc04b.png";